import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { BarChart3Icon, LayersIcon, SlidersHorizontalIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { useAppState } from '../../contexts/AppState';
const navItems = [{
  to: '/queue',
  label: 'Work Queue',
  icon: LayersIcon
}, {
  to: '/reporting',
  label: 'Reporting',
  icon: BarChart3Icon
}, {
  to: '/configuration',
  label: 'Configuration',
  icon: SlidersHorizontalIcon
}];
export function AppShell({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    hasDraftChanges
  } = useAppState();
  const location = useLocation();
  return <div className="flex min-h-full w-full flex-col bg-canvas" data-id="element-96" data-mp="7sekar8vmhju">
      <header className="sticky top-0 z-30 border-b border-ink-200 bg-white/90 backdrop-blur" data-id="element-97" data-mp="2uuseoj9a69f">
        <div className="mx-auto flex h-16 w-full max-w-[1560px] items-center gap-8 px-5 sm:px-8" data-id="element-98" data-mp="109qm0yhy2g8p">
          <div className="flex items-center gap-2.5" data-id="element-99" data-mp="vjjzr5awn7tm">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-600 text-sm font-bold text-white" data-id="element-100" data-mp="vhpa5doourj7">
              H
            </div>
            <div className="leading-tight" data-id="element-101" data-mp="2ge67ddkuk7w7">
              <p className="text-sm font-semibold tracking-tight text-ink-900" data-id="element-102" data-mp="2gcuzb1kdcdza">Harborline</p>
              <p className="text-[11px] font-medium text-ink-500" data-id="element-103" data-mp="22lq5wh7lghxe">Lead Command</p>
            </div>
          </div>

          <nav aria-label="Primary" className="flex items-center gap-1" data-id="element-104" data-mp="26lqkq2yluv4z">
            {navItems.map(({
            to,
            label,
            icon: Icon
          }) => {
            const active = location.pathname.startsWith(to);
            return <NavLink key={to} to={to} className={twMerge('flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors', active ? 'bg-ink-100 text-ink-900' : 'text-ink-500 hover:bg-ink-50 hover:text-ink-800')} data-id="element-105" data-mp="1jndoy9afy3r9">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-106" data-mp="uv2etv3b2a89" />
                  {label}
                  {to === '/configuration' && hasDraftChanges ? <span className="ml-0.5 h-1.5 w-1.5 rounded-full bg-amber-500" aria-hidden="true" data-id="element-107" data-mp="pxke2rzfz1bc" /> : null}
                </NavLink>;
          })}
          </nav>

          <div className="ml-auto flex items-center gap-3" data-id="element-108" data-mp="gwumy1l4lz3y">
            <div className="hidden text-right leading-tight sm:block" data-id="element-109" data-mp="1djzao3ecpasl">
              <p className="text-sm font-medium text-ink-900" data-id="element-110" data-mp="19jp68v67isfu">Sarah Johnson</p>
              <p className="text-[11px] text-ink-500" data-id="element-111" data-mp="19lt7t6gmvfcy">Loan Officer · Pacific Team</p>
            </div>
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-ink-900 text-xs font-semibold text-white" data-id="element-112" data-mp="ztnffvmgyvx8">
              SJ
            </div>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-[1560px] flex-1 px-5 pb-16 pt-6 sm:px-8" data-id="element-113" data-mp="1sib7ca1q4jjr">{children}</main>
    </div>;
}